import temp from "./temp";
import createInstance from "../index";

export default createInstance(temp);
